export const reactive = [
    // { name: "با بیشترین سود", value:"maximumProfit" }, 
    { name: "غیرفعال", value: "disable" },
    { name: "فعال", value: "enable" },
    // {name: "هوشمند", value: "smart"}
]
export const strategy = [
    { name: "کمترین قیمت", value: 'lowestPrice' },
    { name: "موجود در باکس (پلکانی)", value: 'boxStep' },
    // { name: "موجود در باکس(با کمترین قیمت)", value: 'boxLowestPrice'},
    { name: "موجود در باکس (لحظه‌ای)", value: 'boxMoment' },
    // { name: "رقابت هوشمند", value: 'smart' }
]
export const saleType = [
    // { name: "فروش ویژه", value: 'special' }, 
    { name: "فروش عادی", value: 'normal' },
    // { name: "فروش هوشمند", value: 'smart' },
]
export const priceIncrease = [
    { name: "آزاد (محدود به حداکثر سود)", value: 'free' },
    // { name: "محدود به حداکثر سود", value: 'maximumProfit' },
    { name: "محدود به قیمت مرجع", value: 'referencePrice' }
]
export const competitionType = [
    { name: "ثابت", value: 'fix' },
    //  { name: "چرخشی", value: 'cycle' }
]

export const variantState = [
    { name: "در باکس فروش", value: "insideBox" },
    { name: "خارج از باکس فروش", value: "outsideBox" },
    { name: "ربات غیرفعال", value: "ActiveSellStatus" },
    { name: "خطا", value: "ErrorFilter" }
]

export const ErrorsFilterValues = [
    { name: "غیر فعال شدن کالا", value: 'DeActive' },
    { name: "اتمام موجودی", value: 'no_stock' },
    { name: "بازه‌ی نادرست قیمت‌گذاری", value: 'out_of_range' },
    { name: "تخفیف کمتر از میزان اعلام شده‌ی دیجی‌کالا در پروموشن", value: 'promo_min_error' },
    { name: "خطا از سمت دیجی‌کالا", value: 'DK_Error' },
    { name: "خطا در ارتباط با ربات", value: 'Mobisha_Error' },
    { name: "قیمت پایین‌تر از حد مجاز قیمت مرجع است", value: 'resource_price' },
]

export const ErrorCodes = {
    'error': '.خطا در ارتباط با ربات! لطفا با پشتیبانی تماس بگیرید',
    'DeActive': ' .این کالا در دیجی کالا غیرفعال است',
    'no_stock': '.موجودی کالا به پایان رسیده است',
    'DK_Error': '.وجود خطا از سمت دیجی‌کالا! در صورت تکرار خطا با پشتیبانی تماس بگیرید',
    'Mobisha_Error': '.خطا در ارتباط با ربات! لطفا با پشتیبانی تماس بگیرید',
    'outOfRange': '.امکان قیمت‌گذاری در بازه اعلام شده وجود ندارد',
    'out_of_range': '.امکان قیمت‌گذاری در بازه اعلام شده وجود ندارد',
    'promo_min_error': '.امکان درج قیمت کم‌تر از قیمت اعلام شده در تخفیف هوشمند نمی‌باشد',
    'resource_price': ".قیمت پایین‌تر از حد مجاز قیمت مرجع است"
}
// export const deliveredBy = [
//     { name: "دیجی‌کالا", value: 'digikala' },
//     { name: "هر دو", value: 'both' }
// ]
// export const marginType = [
//     { name: "درصد", value: "percent" },
//     { name: "قیمت", value: "price" },
//     { name: "بیشترین قیمت ", value: "maxPrice" }]

// export const PricingFilters =[
//     { tag:"pricingStrategy",name:"استراتژی",
//     array:[{ name: "کمترین قیمت", value: 'lowestPrice' },{ name: "موجود در باکس(پلکانی)", value: 'boxStep' },{ name: "موجود در باکس(با کمترین قیمت)", value: 'boxLowestPrice'},{ name: "موجود در باکس(لحظه‌ای)", value: 'boxMoment' }, { name: "رقابت هوشمند", value: 'smart' }]
//     },
//     {tag:"sellingType", name:"نوع فروش" ,
//     array: [{ name: "فروش ویژه", value: 'special' }, { name: "فروش عادی", value: 'normal' },{ name: "فروش هوشمند", value: 'smart' },]
//     },

//     {tag:"priceIncrease",name:"افزایش قیمت",
//     array:[{ name: "آزاد ", value: 'free' }, { name: "محدود به حداکثر سود", value: 'maximumProfit' }, { name: "محدود به قیمت مرجع", value: 'referencePrice' }]
//     },
//     {tag:"competitionType",name:"نوع رقابت"  ,array:[{ name: "ثابت", value: 'fix' }, { name: "چرخشی", value: 'cycle' }]
//     },
//     {
//      tag:"shippingOptions", name:"ارسال توسط", array : [{ name: "دیجی‌کالا", value: 'digikala' }, { name: "هر دو", value: 'both' }]
//     }]

